export const WEB_UPDATE_EVENT = 'plugin_web_update_notice'
